import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css'

class CustomTable extends Component {

	subComponentFunction(needToHide, subComponent) {
		return (row) => {
			return (
				<div className="table-sub-component-wrapper text-left">
					{
						needToHide.map((column, index) => {
							return (
								<div className="table-sub-component-item" key={index}>
									<div className="column-header">{column.Header}: </div>
									<div className="column-data">
										{
											(column.Cell)
												? (
														(typeof column.accessor !== 'string')
															? <column.Cell value={column.accessor(row.original)}/>
															: <column.Cell value={row.original[column.accessor]}/>
													)
												: (
														(typeof column.accessor !== 'string')
															? column.accessor(row.original)
															: row.original[column.accessor]
													)
										}
									</div>
								</div>
							);
						})
					}

					{ (subComponent) && subComponent(row) }
				</div>
			)
		}
	}

	render() {
		const {
			data, columns, className, loading, showPagination, defaultPageSize, pageSizeOptions,
			sortable, resizable, filterable, defaultFilterMethod, SubComponent, ...rest
		} = this.props;

		const shouldShowPagination = data.length > defaultPageSize ? showPagination : false;

		const needToHide = [], displayColumns = [];
		columns.forEach(column => {
			if(column.hideOn && column.hideOn === 'always') {
				needToHide.push(column);
			}
			else if(column.hideOn && column.hideOn === 'tab' && window.innerWidth < 992) {
				needToHide.push(column);
			}
			else if(column.hideOn && (column.hideOn === 'tab' || column.hideOn === 'mobile') && window.innerWidth < 767) {
				needToHide.push(column);
			}
			else {
				displayColumns.push(column);
			}
		});

		const actualSubComponent = (needToHide.length || SubComponent) ? this.subComponentFunction(needToHide, SubComponent) : false;

		return (
				<ReactTable
					data={data}
					columns={displayColumns}
					className={className}
					loading={loading}
					showPagination={shouldShowPagination}
					defaultPageSize={defaultPageSize}
					pageSizeOptions={pageSizeOptions}
					sortable={sortable}
					resizable={resizable}
					filterable={filterable}
					defaultFilterMethod={defaultFilterMethod}
					SubComponent={actualSubComponent}
					{...rest}
				/>
		)
	}
}

CustomTable.defaultProps = {
	className: ' -highlight text-center -striped',
	loading: false,
	showPagination: true,
	defaultPageSize: 10,
	pageSizeOptions: [10, 20, 50],
	sortable: true,
	resizable: false,
	filterable: true,
	defaultFilterMethod: (filter, row, column) => {
		const id = filter.pivotId || filter.id;
		return row[id] !== undefined && row[id] !== null && filter.value.trim().length
			? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
			: true;
	}
};

CustomTable.propTypes = {
	data: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	className: PropTypes.string,
	loading: PropTypes.bool,
	showPagination: PropTypes.bool,
	defaultPageSize: PropTypes.number,
	pageSizeOptions: PropTypes.array,
	sortable: PropTypes.bool,
	resizable: PropTypes.bool,
	filterable: PropTypes.bool,
	defaultFilterMethod: PropTypes.func
};

export default CustomTable;
